<script setup>
/**
 * GlobalFeaturePopup
 *
 * A single, app-root feature popup driven by the geo store. Lets any part of the
 * app (e.g. a feature link inside a daily-review report) open a feature's popup on
 * the persistent map without owning a FeatureCollectionRenderer ref. Reuses the
 * standard FeaturePopup (incl. its "Open" button).
 */
import { computed } from 'vue'
import { useUserStore } from '@/stores/user'
import { useGeoStore } from '@/stores/geo'
import FeaturePopup from '@/components/feature/FeaturePopup.vue'

const userStore = useUserStore()

const geoStore = useGeoStore()

const popup = computed(() => geoStore.featurePopup)
const map = computed(() => geoStore.map)
const settings = computed(() => userStore.settings || { tz: 'UTC' })

const close = () => geoStore.closeFeaturePopup()
</script>

<template>
  <FeaturePopup
    v-if="popup.visible && popup.feature && popup.coordinates && map"
    :map="map"
    :coordinates="popup.coordinates"
    :is-visible="popup.visible"
    :feature="popup.feature"
    :counter="popup.counter"
    :settings="settings"
    @close="close"
  />
</template>
